var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", [_vm._v("Informe Gráfico de Temperatura")])],
        1
      ),
      _c("v-divider"),
      _c("br"),
      _c("br"),
      _c(
        "v-flex",
        { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.flota.label,
                      items: _vm.flotasList,
                      "item-text": "__nom_flota",
                      "item-value": "cod_flota",
                      clearable: "",
                      required: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.clearAutocomplete("flota")
                      }
                    },
                    model: {
                      value: _vm.formFields.flota.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.flota, "value", $$v)
                      },
                      expression: "formFields.flota.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm2: "", md2: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.patente.label,
                      items: _vm.patentesList,
                      "item-text": "patente_vehiculo",
                      "item-value": "cod_vehiculo",
                      clearable: "",
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.patente.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.patente, "value", $$v)
                      },
                      expression: "formFields.patente.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm2: "", md1: "" } },
                [
                  _c("v-autocomplete", {
                    attrs: {
                      label: _vm.formFields.sonda.label,
                      items: _vm.sondasList,
                      "item-text": "patente_vehiculo",
                      "item-value": "cod_vehiculo",
                      clearable: "",
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.sonda.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.sonda, "value", $$v)
                      },
                      expression: "formFields.sonda.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm2: "", md2: "" } },
                [
                  _c("DatePicker", {
                    attrs: {
                      label: _vm.formFields.fechaInicio.label,
                      "error-messages": _vm.errors.collect(
                        _vm.formFields.fechaInicio.id
                      ),
                      id: _vm.formFields.fechaInicio.id,
                      min: _vm.formFields.fechaInicio.min.format("YYYY-MM-DD"),
                      max: _vm.formFields.fechaInicio.maxDate.format(
                        "YYYY-MM-DD"
                      )
                    },
                    model: {
                      value: _vm.formFields.fechaInicio.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.fechaInicio, "value", $$v)
                      },
                      expression: "formFields.fechaInicio.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm2: "", md2: "" } },
                [
                  _c("DatePicker", {
                    attrs: {
                      label: _vm.formFields.fechaFin.label,
                      "error-messages": _vm.errors.collect(
                        _vm.formFields.fechaFin.id
                      ),
                      id: _vm.formFields.fechaFin.id,
                      min: _vm.formFields.fechaFin.min.format("YYYY-MM-DD"),
                      max: _vm.formFields.fechaFin.maxDate.format("YYYY-MM-DD")
                    },
                    model: {
                      value: _vm.formFields.fechaFin.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.fechaFin, "value", $$v)
                      },
                      expression: "formFields.fechaFin.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "", md6: "", lg2: "" } },
                [
                  _c(
                    "v-btn",
                    { on: { click: _vm.handleBuscarClick } },
                    [
                      _c("v-icon", [_vm._v("search")]),
                      _vm._v("\n          Buscar\n        ")
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    { on: { click: _vm.clearFilters } },
                    [
                      _c("v-icon", [_vm._v("clear")]),
                      _vm._v("\n          Limpiar\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("br"),
      _c("br"),
      _c(
        "div",
        {
          staticClass: "right",
          staticStyle: { display: "flex", "margin-top": "-40px" }
        },
        [
          _c(
            "v-btn",
            {
              staticStyle: { height: "48px" },
              attrs: { color: "#ffe800" },
              on: {
                click: function($event) {
                  return _vm.handleModal("create")
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  staticStyle: {
                    "font-size": "160%",
                    "margin-right": "7% !important"
                  },
                  attrs: { dark: "", left: "" }
                },
                [_vm._v("add_circle_outline\n      ")]
              ),
              _c("span", [_vm._v("Generar Informe")])
            ],
            1
          )
        ],
        1
      ),
      _c("br"),
      _c("br"),
      _c(
        "v-flex",
        {
          staticStyle: { "max-height": "520px" },
          attrs: { sm12: "", md12: "" }
        },
        [
          _c(
            "v-card",
            { staticClass: "idCard" },
            [
              _c("lineComp", { ref: "lineRefIgnicion", attrs: { height: 520 } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }